import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/middleware'
import { RolesAndPermissionsPage } from '@/features/access-control/roles-and-permissions-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/roles'
)({
  beforeLoad: async () => {
    await requireAuth()
  },
  component: RolesAndPermissionsPage,
})
